import $ from 'jquery'


import { observeAnimations } from './observers/animations'
import observeUnscrolled from './observers/unscrolled'
import observeViewport from './observers/viewport'
import initPage from './page'
import initSummary from './summary'
import initNavigation from './navigation'
import initFallback from './fallback'
import initPopups from './popups'
import { initCookies } from './data/cookies'
import initVendors from './vendors'
import initResults from "./results";
import { initPostGrid } from './postgrid';
// import {returnMsnry} from './postgrid';
import initModules from './modules'
import initSearch from "./search";
import { initDebugger } from "./debug";
import { observeXHR } from "./observers/xhr";
import initFilters from './elements/filters'
import initUI from './ui'




let pageType;
const sum = 'section.summary';
const pageTransitionPause = 1;


// Event Observers
function observers() {
    observeUnscrolled();
    observeViewport();
    if (pageType !== 'home') {
        observeAnimations()
    }

    observeXHR()
}

function init() {

    // initDebugger()

    initCookies();


    //
    initVendors();
    initModules();

    getPageType();
    if (pageType !== 'home') {
        initSummary()
    } else {

    }

    initNavigation();
    initPopups();

    initPostGrid();


    // incl page trans action
    initUI();




    initPage();
    observers();

    // search
    initResults();

    initFilters();

    initSearch();
    // set intro load
    setTimeout(function () {
        $('body').addClass('init')
    }, 1);
    $(window).ready(function () {
        setTimeout(function () {
            $('body').addClass('loaded')
        }, pageTransitionPause)
    })





}

function T(slug, type = 'post_type') {
    return publisher[type][slug].post_type;
}

function getPageType() {
    if (document.body.classList.contains('home')) {
        pageType = 'home'
    } else if (document.body.classList.contains('publication-template')) {
        pageType = 'publication'
    } else if (document.body.classList.contains('wiki-template')) {
        pageType = 'single-wiki'
    } else {
        pageType = 'page'
    }
}

initFallback();
$(document).ready(function () {
    // setTimeout(function () {

    init()
    // }, 3000);
});

